import { format } from 'date-fns'

import { ReportType, reportFileApi } from 'redux/services/report-file'

import { AppButton } from 'components/AppButton'
import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppTable } from 'components/AppTable'

export const AcquiredClientsReports = () => {
  const { data, isFetching } = reportFileApi.useGetReportFilesQuery({
    type: ReportType.acquiredClients,
  })

  return (
    <AppLayoutTable title="Отчеты - Привлеченные">
      {isFetching && <AppLoader />}
      {!isFetching && (
        <AppTable
          loading={isFetching}
          dataSource={data}
          headers={[
            {
              data: 'Название',
              key: 'name',
              width: 50,
            },
            {
              data: 'Дата создания',
              key: 'created_at',
              render: date => {
                return format(new Date(date), 'dd.MM.yyyy HH:mm:ss')
              },
              width: 50,
            },
            {
              data: 'Статус',
              key: 'status',
              width: 50,
            },
            {
              data: 'Файл',
              key: 'file_url',
              render: file =>
                file && (
                  <a href={file} target="_blank" rel="noreferrer">
                    <AppButton variant="siren_dashed_border" size="small">
                      Скачать файл
                    </AppButton>
                  </a>
                ),
              width: 50,
            },
          ]}
        />
      )}
    </AppLayoutTable>
  )
}
